<app-posts type="Client"></app-posts>